import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  title: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: "#74D588", // rgba(128, 0, 128, 0.50)
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },
  detailTitle: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "36px",
    },
    // "& button": {
    //   height: "50px",
    //   width: "150px",
    //   color: "#FF0000",
    //   background: "transparent",
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   border: "2px solid #FF0000",
    //   borderRadius: "25px",
    //   fontSize: "20px",
    //   gap: "5px",
    //   "& img": {
    //     width: "30px",
    //     height: "30px",
    //   },
    // },
  },

  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },

  medicationModal: {
    width: 1450,
    // height: "600px",
    // maxHeight: "80vh",
    overflowY: "auto",
    // height: 500,
    // "& .mantine-Modal-content": {
    //   height: "300px !important",
    // },
    // "& .mantine-Modal-inner": {
    //   padding: "0px !important",
    // },
    "& .mantine-Paper-root": {
      overflow: "hidden !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      display: "none",
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },
  mwd: {
    width: "100%",
  },
  mainContentWarpper: {
    width: "100%",
    height: "70vh",
    maxHeight: "900px",
    overflowY: "auto",
  },
  mainContent: {
    width: "100%",
    // height: "100%",
    padding: "3rem 4rem 5rem 8rem",
    display: "flex",
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  details: {
    width: "75%",
  },
  personInfo: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    flexDirection: "column",
    width: "25%",
    "& img": {
      width: "170px",
      height: "160px",
      objectFit: "cover",
      borderRadius: "10px",
    },
    "& h3": {
      margin: "0",
      marginTop: "10px",
      textAlign: "center",
      color: "#000",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
    "& p": {
      margin: "0",
      marginTop: "5px",
      textAlign: "center",
      color: "#979797",
      fontFamily: "Inter",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
    },
  },

  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginBottom: "30px",
    "& p": {
      margin: "0",
      fontSize: "32px",
    },
  },
  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "210px",
    height: "100px",
    // background: "#fdf5e3",
    "& h3": {
      margin: "0",
      fontSize: "30px",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "16px !important",
    },
  },
  span1: {
    fontWeight: "600",
    fontSize: "36px",
  },
  span3: {
    color: "#979797",
    margin: "0",
  },

  outcome: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  redText: {
    color: "#FF0000",
  },
  dispensed: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      fontWeight: "400",
      fontSize: "36px",
      margin: "0",
      marginBottom: "10px",
    },
  },
  quantity: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      margin: "0",
      fontSize: "85px",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "20px ",
    },
  },
  radioContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    "& .mantine-1svz3tp": {
      color: "#232323",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: "800",
      lineHeight: "20px",
    },
    "& .mantine-1cu6yj8:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    borderBottom: "3px solid #979797",
    background: "#F2F2F2",
    // marginTop: "20px",
    gap: "20px",
    paddingInline: "30px",
    paddingBlock: "10px",
    "& .column1": {
      flex: 1,
      "& p": {
        textAlign: "left",
      },
      "& h3": {
        textAlign: "left",
      },
    },
    "& .column2": {
      "& h3": {
        color: "#5C5C5C",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "25px",
        paddingLeft: "20px",
      },
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      color: "#979797",
      fontFamily: "Inter",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
      marginBottom: "20px",
    },
    "& h3": {
      margin: "0",
      textAlign: "center",
      color: "#000",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
  },
  comments: {
    "& .mantine-1ix1d88": {
      borderRadius: "15px",
    },
  },

  upcomingHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255, 186, 69, 0.85)",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },

  quantityInput: {
    "& input": {
      borderRadius: "5px",
      width: "160px",
      height: "100px",
      border: "1px solid #979797",
      fontSize: "60px",
      fontWeight: "bold",
      textAlign: "center",
    },
  },
  medicationBox: {
    marginBottom: "20px",
  },
  saveButton: {
    marginTop: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "rgba(255, 186, 69, 0.85)",
      width: "145px",
      height: "60px",
      color: "#000",

      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "rgba(255, 186, 69, 0.85)",
      },
    },
  },
  updateButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& img": {
      width: "25px",
      height: "25px",
      marginRight: "2px",
    },
    "& button": {
      borderRadius: "5px",
      background: "rgba(255, 186, 69, 0.85)",
      width: "auto",
      height: "40px",
      color: "#000",

      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "rgba(255, 186, 69, 0.85)",
      },
    },
  },
  editButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "transparent",
      width: "auto",
      height: "auto",
      color: "#fab005",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        color: "rgba(255, 186, 69, 0.85)",
        background: "transparent",
      },
    },
  },
  missedBoxWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "30px",
    "& .missedBox": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px 20px 15px 20px",
      borderRadius: "10px",
      border: "1px solid #E5252A",
      "& svg": {
        color: "#E5252A",
      },
      "& p": {
        color: "#E5252A",
        fontSize: "26px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "25px",
        margin: 0,
        marginTop: "10px",
      },
    },
  },

  discontinueBoxWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "30px",
    "& .discontinedBox": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "10px 20px 15px 20px",
      borderRadius: "10px",
      border: "1px solid #A52A2A",
      "& svg": {
        color: "#A52A2A",
      },
      "& p": {
        color: "#A52A2A",
        fontSize: "26px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "25px",
        margin: 0,
        marginTop: "10px",
      },
    },
  },
  statusBox: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    "& img": {
      width: "20px",
      height: "20px",
    },
    "& p": {
      fontWeight: 800,
    },
  },

  // ── DRAWER STYLES ────────────────────────────────────────────────────
  drawerBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  modalTopBar: {
    width: "100%",
    height: "64px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
    borderRadius: "16px 16px 0 0",
  },
  modalTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    fontFamily: "Inter",
  },
  modalCloseBtn: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#555",
    lineHeight: 1,
    padding: "4px 8px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.06)" },
  },
  formBox: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    backgroundColor: "#F5F5F5",
  },
  prnWrapper: {
    width: "100%",
    padding: "24px 20px",
  },
  labelStyle: {
    color: "#262626",
    marginBottom: "6px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
  },
  inputStyle: {
    marginBottom: "12px",
    "& .mantine-Input-wrapper": {
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        color: "#262626",
      },
      "& .mantine-Textarea-input": {
        height: "auto",
        overflowY: "auto",
        padding: "10px 14px",
      },
      "& .mantine-TimeInput-input, & .mantine-DateInput-input": {
        paddingLeft: 36,
      },
    },
    "& .mantine-DatePickerInput-wrapper": {
      "& .mantine-DatePickerInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-DatePickerInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-TimeInput-wrapper": {
      "& .mantine-TimeInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-TimeInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  contentBox: {
    background: "#FCFCFC",
    borderRadius: 16,
    border: "1px solid #E5E5E5",
    padding: "15px 13px",
    marginBottom: "16px",
  },
  grayBox: {
    padding: 8,
    marginBottom: 12,
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    backgroundColor: "#F5F5F5",
    "& .medName": {
      alignItems: "center",
      gap: 4,
      marginBottom: 8,
      "& p": {
        fontSize: "16px",
        fontWeight: 600,
        fontFamily: "Inter",
        color: "#171717",
        margin: 0,
      },
    },
  },
  medInfoBox: {
    padding: 12,
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  medAcc: {
    flex: 1,
  },
  accordionSelectItem: {
    borderRadius: "8px !important",
    background: "#FFFFFF !important",
    border: "1px solid #E5E5E5 !important",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    overflow: "hidden",
    "&[data-active]": { background: "#FFFFFF !important" },
  },
  accordionSelectControl: {
    fontSize: "14px",
    fontFamily: "Inter",
    color: "#262626",
    fontWeight: 400,
    minHeight: "44px !important",
    padding: "0 14px !important",
    "& .mantine-Accordion-chevron": { color: "#667085" },
  },
  quantityRow: {
    alignItems: "center",
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    overflow: "hidden",
    background: "#FAFAFA",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    paddingInline: "13px",
    marginTop: 6,
    width: 275,
  },
  qtyBtn: {
    width: "26px !important",
    minWidth: "26px",
    height: "26px !important",
    minHeight: "26px",
    borderRadius: "50% !important",
    background: "#FFF !important",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    border: "none !important",
    color: "#000000",
    "&:hover": { background: "#EBEBEB !important" },
  },
  qtyInput: {
    flex: 1,
    height: "44px",
    border: "none",
    outline: "none",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#262626",
    background: "transparent",
    padding: "0 8px",
    width: "100%",
    MozAppearance: "textfield",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  prnSaveBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    height: 60,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 18,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    ":hover": { backgroundColor: "#FFAF4A", opacity: 0.8 },
  },
  medicineInnerCard: {
    padding: "12px 14px",
    background: "#FFF",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    marginBottom: 16,
  },
  viewClientCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFFF",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    padding: "12px 16px",
    marginBottom: 16,
  },
  clientAvatar: {
    width: 44,
    height: 44,
    borderRadius: 8,
    objectFit: "cover",
  },
  clientName: {
    fontSize: "14px !important",
    fontWeight: "600 !important",
    color: "#000 !important",
    fontFamily: "Inter",
  },
  clientId: {
    fontSize: "12px !important",
    color: "#8C8C8C !important",
    fontFamily: "Inter",
  },
  narcoticBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 8px",
    borderRadius: 16,
    background: "#FEF3F2",
    color: "#B42318",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  medDetailsCard: {
    background: "#F5F5F5",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    padding: "14px 16px",
    marginBottom: 16,
  },
  medDetailsTitle: {
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
    margin: 0,
  },
  editBtnOrange: {
    backgroundColor: "#FFAF4A",
    color: "#171717",
    borderRadius: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "600",
    height: "40px !important",
    padding: "0 16px !important",
    border: "none !important",
    "&:hover": { backgroundColor: "#FFAF4A", opacity: 0.8 },
  },
  medDetailsInner: {
    background: "#FFFFFF",
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    padding: "12px 16px",
    width: "100%",
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
  },
  medDetailsCol: {
    flex: 1,
    minWidth: 80,
  },
  medDetailsLabel: {
    color: "#8C8C8C",
    margin: "0 0 6px 0",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 400,
  },
  medDetailsValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
    fontFamily: "Inter",
    margin: 0,
  },
  medDetailsSigImg: {
    height: 36,
    maxWidth: "100%",
    objectFit: "contain",
  },
  medDetailsSigText: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Island Moments",
    color: "#171717",
    lineHeight: "normal",
    margin: 0,
  },
  cancelBtn: {
    backgroundColor: "#F9FAFB",
    color: "#1D2939",
    border: "1px solid #D0D5DD !important",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    height: "40px",
    fontFamily: "Inter",
    padding: "0 16px !important",
    "&:hover": { backgroundColor: "#F9FAFB", opacity: 0.8 },
  },
  editDetailsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    width: "100%",
  },
  timeInputLeftIcon: {
    pointerEvents: "all",
    cursor: "pointer",
  },
  sigBox: {
    background: "#F5F5F5",
    minHeight: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
  },
  statusLabel: {
    gap: "4px",
    alignItems: "center",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
    "& img": {
      width: 36,
      height: 18,
    },
  },
  statusBadge: {
    padding: "2px 8px",
    borderRadius: 16,
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  medFreqAndCountRow: {
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 7,
    borderBottom: "1px solid #E5E5E5",
    "& .freqAndTime": {
      "& .frequency": {
        fontSize: "16px",
        fontWeight: 600,
        color: "#404040",
        fontFamily: "Inter",
        margin: 0,
      },
      "& .time": {
        fontSize: "10px",
        fontWeight: 400,
        color: "#737373",
        fontFamily: "Inter",
        margin: 0,
      },
    },
  },
  quantityAndInfoRow: {
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlock: 12,
    "& .name": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#404040",
      fontFamily: "Inter",
      margin: 0,
    },
    "& .dosage": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
      fontFamily: "Inter",
      margin: 0,
    },
  },
  statusRadioRow: {
    gap: 16,
    marginBlock: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  viewQtyBox: {
    textAlign: "right",
  },
  viewQtyNumber: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#404040",
    fontFamily: "Inter",
    margin: 0,
  },
  viewQtyLabel: {
    fontSize: "10px",
    fontWeight: 400,
    color: "#737373",
    fontFamily: "Inter",
    margin: 0,
  },
  viewInfoBox: {
    backgroundColor: "#FFF",
    borderRadius: 8,
    padding: "10px 12px",
    marginTop: 4,
  },
  viewInfoRow: {
    justifyContent: "space-between",
    gap: 12,
  },
  viewInfoLabel: {
    fontSize: "11px",
    fontWeight: 400,
    color: "#737373",
    fontFamily: "Inter",
    margin: "0 0 4px 0",
  },
  viewInfoValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
    fontFamily: "Inter",
    margin: 0,
  },
  outcomesSection: {
    marginTop: 12,
    paddingTop: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  outcomesHeading: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
    fontFamily: "Inter",
    margin: "0 0 6px 0",
  },
  outcomeRow: {
    alignItems: "center",
    gap: 8,
    "& img": {
      width: 36,
      height: 18,
    },
    "& span": {
      fontSize: "12px",
      fontWeight: 500,
      fontFamily: "Inter",
    },
  },
  medRefreshBtn: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
    gap: 8,
  },
  prnMedDeleteBtn: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#F04438",
    gap: 8,
    backgroundColor: "#F5F5F5",
    padding: "8px 13px",
    borderRadius: 8,
    height: 48,
    marginBottom: 8
  },
    unlimitedBadgeText: {
    // Unlimited
    color: "#344054",
    fontSize: 12,
    fontFamily: "Inter",
    fontWeight: "500",
    wordWrap: "break-word",
  },
  unlimitedBadge: {
    width: "100%",
    height: "100%",
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 4,
    paddingBottom: 4,
    background: "#F2F4F7",
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex",
  },
}));

export default useStyles;
